import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { DownloadService } from './download.service';

@Injectable()
export class MetricService {
  constructor(
    private _api: ApiService,
    private readonly downloadService: DownloadService,
  ) {}

  getMetrics(query: string, page: number, perPage: number, sort = 'userId', ascending = false): Observable<any> {
    return this._api
      .get(`/metric?query=${encodeURIComponent(query)}&limit=${perPage}&offset=${page}&sort=${sort}&ascending=${ascending}`)
      .pipe(map((data: any) => data));
  }

  exportMetrics(query: string, sort = 'userId', ascending = false) {
    const filename = `metrics-search-results-${this.downloadService.yyyymmddhhmmss(new Date())}.xls`;
    const url = `/metric/export?query=${encodeURIComponent(query)}&sort=${sort}&ascending=${ascending}`;
    return this._api.getExport(url, filename);
  }
  submitMetric(quizInfo) {
    const results = this._api
      .post(`/metric`, {
        ...quizInfo,
      })
      .pipe(map((data) => data));
    return results;
  }
}
